(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
class ReviewsPagination extends HTMLElement {
  constructor() {
    super();
    
    // Get elements
    this.reviewsList = document.getElementById('reviews-list');
    this.paginationElement = document.getElementById('pagination');
    this.reviewsPerPage = 5;
    this.currentPage = 1;

    // Initialize
    this.initialize();
  }

  initialize() {
    // Get all review items
    this.allReviews = Array.from(this.reviewsList.querySelectorAll('.review-item'));
    
    if (this.allReviews.length > this.reviewsPerPage) {
      this.showPage(1);
      this.setupPagination();
    }
  }

  showPage(pageNumber) {
    const start = (pageNumber - 1) * this.reviewsPerPage;
    const end = start + this.reviewsPerPage;

    // Hide all reviews
    this.allReviews.forEach(review => {
      review.style.display = 'none';
    });

    // Show only reviews for current page
    this.allReviews.slice(start, end).forEach(review => {
      review.style.display = 'flex';
    });

    this.currentPage = pageNumber;
    if (this.paginationElement) {
      this.updatePaginationButtons();
    }
  }

  setupPagination() {
    const pageCount = Math.ceil(this.allReviews.length / this.reviewsPerPage);
    
    this.paginationElement.innerHTML = '';
    
    for (let i = 1; i <= pageCount; i++) {
      const button = document.createElement('button');
      button.className = `page-number ${i === this.currentPage ? 'active' : ''}`;
      button.textContent = i;
      
      button.addEventListener('click', (e) => {
        // Prevent default behavior
        e.preventDefault();
        
        this.showPage(i);
        
        // Instead of scrolling to top, stay in the current position
        // or optionally scroll to the reviews section smoothly
        const reviewsSection = document.querySelector('.reviews__container');
        if (reviewsSection) {
          // Scroll just to the top of the reviews section
          reviewsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
      
      this.paginationElement.appendChild(button);
    }
  }

  updatePaginationButtons() {
    const buttons = this.paginationElement.querySelectorAll('.page-number');
    buttons.forEach((button, index) => {
      button.classList.toggle('active', index + 1 === this.currentPage);
    });
  }
}

customElements.define('reviews-pagination', ReviewsPagination);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-benefits-accordion"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const accordionToggles = document.querySelectorAll('[data-toggle="accordion"]');
  
  accordionToggles.forEach(toggle => {
    toggle.addEventListener('click', function() {
      const parent = this.parentNode;
      const isActive = parent.classList.contains('active');
      
      // Close all items
      document.querySelectorAll('.benefit-item').forEach(item => {
        item.classList.remove('active');
      });
      
      // If the clicked item wasn't active, open it
      if (!isActive) {
        parent.classList.add('active');
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-carousel"] && !Shopify.designMode) return;
  try {
    
  class RaineCarousel {
    constructor(element) {
      this.carousel = element;
      this.track = element.querySelector('.raine-carousel__track');
      this.slides = Array.from(element.querySelectorAll('.raine-carousel__slide'));
      this.dots = Array.from(element.querySelectorAll('.raine-carousel__dot'));
      this.prevButton = element.querySelector('.raine-carousel__nav-button--prev');
      this.nextButton = element.querySelector('.raine-carousel__nav-button--next');
      this.currentIndex = 0;
      this.slideCount = this.slides.length;
      this.autoplayEnabled = this.carousel.dataset.autoplay === 'true';
      this.autoplayDelay = parseInt(this.carousel.dataset.delay) || 5000;
      this.autoplayInterval = null;
      this.slidesPerView = 4.5; // Default 4 slides per view
      this.isMobile = window.innerWidth <= 767;
      
      this.init();
    }

    init() {
      this.handleResponsive();
      this.addEventListeners();
      if (this.autoplayEnabled && !this.isMobile) {
        this.startAutoplay();
      }
      this.updateSlides();
      window.addEventListener('resize', () => {
        const wasMobile = this.isMobile;
        this.isMobile = window.innerWidth <= 767;
        
        // If transitioning between mobile and desktop, handle view change
        if (wasMobile !== this.isMobile) {
          // Reset the current index when switching layouts
          this.currentIndex = 0;
        }
        
        this.handleResponsive();
      });
    }
    
    handleResponsive() {
      const width = window.innerWidth;
      
      if (width <= 767) {
        this.isMobile = true;
        // In mobile view, no need for horizontal sliding as we display vertically
        this.slidesPerView = 1;
        // Stop autoplay if it's running
        this.stopAutoplay();
      } else if (width <= 992) {
        this.isMobile = false;
        this.slidesPerView = 2;
      } else if (width <= 1200) {
        this.isMobile = false;
        this.slidesPerView = 3;
      } else {
        this.isMobile = false;
        this.slidesPerView = 4;
      }
      
      if (!this.isMobile) {
        // Re-enable autoplay for non-mobile if it was set
        if (this.autoplayEnabled && !this.autoplayInterval) {
          this.startAutoplay();
        }
      }
      
      this.updateSlides();
    }

    addEventListeners() {
      if (this.prevButton && this.nextButton) {
        this.prevButton.addEventListener('click', () => this.prev());
        this.nextButton.addEventListener('click', () => this.next());
      }
      
      if (this.dots && this.dots.length) {
        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => this.goToSlide(index));
        });
      }

      if (this.autoplayEnabled) {
        this.carousel.addEventListener('mouseenter', () => this.stopAutoplay());
        this.carousel.addEventListener('mouseleave', () => {
          if (!this.isMobile) {
            this.startAutoplay();
          }
        });
      }

      // Touch events for mobile horizontal swiping
      if (!this.isMobile) {
        let touchStartX = 0;
        let touchEndX = 0;

        this.carousel.addEventListener('touchstart', (e) => {
          touchStartX = e.changedTouches[0].screenX;
        }, { passive: true });

        this.carousel.addEventListener('touchend', (e) => {
          touchEndX = e.changedTouches[0].screenX;
          this.handleSwipe(touchStartX, touchEndX);
        }, { passive: true });
      }
    }

    handleSwipe(startX, endX) {
      if (this.isMobile) return; // No swiping in vertical mobile mode
      
      const diff = startX - endX;
      const threshold = 50; // minimum distance for swipe

      if (Math.abs(diff) > threshold) {
        if (diff > 0) {
          this.next();
        } else {
          this.prev();
        }
      }
    }

    updateSlides() {
      if (this.isMobile) {
        // In mobile view, we don't need to transform the track
        // All slides are displayed vertically
        this.track.style.transform = '';
        
        // Hide navigation buttons in mobile view
        if (this.prevButton) this.prevButton.style.display = 'none';
        if (this.nextButton) this.nextButton.style.display = 'none';
        
        return;
      }
      
      // Show navigation buttons in desktop view
      if (this.prevButton) this.prevButton.style.display = '';
      if (this.nextButton) this.nextButton.style.display = '';
      
      // Calculate the slide width based on the number of slides per view
      const slideWidth = 100 / this.slidesPerView;
      
      // Move the track based on the current index
      const offset = -this.currentIndex * slideWidth;
      this.track.style.transform = `translateX(${offset}%)`;
      
      // Update the navigation button states
      if (this.prevButton) {
        this.prevButton.classList.toggle('disabled', this.currentIndex === 0);
      }
      
      if (this.nextButton) {
        this.nextButton.classList.toggle('disabled', this.currentIndex >= this.slideCount - this.slidesPerView);
      }
      
      // Update active states for dots
      if (this.dots && this.dots.length) {
        this.dots.forEach((dot, index) => {
          dot.classList.toggle('active', index === this.currentIndex);
        });
      }
    }

    next() {
      if (this.isMobile) return; // No next button functionality in mobile vertical mode
      
      // Check if we've reached the last possible slide position
      if (this.currentIndex >= this.slideCount - Math.floor(this.slidesPerView)) return;
      
      // Ensure we can only scroll to a point where the last slide is visible
      const maxIndex = Math.max(0, this.slideCount - Math.floor(this.slidesPerView));
      this.currentIndex = Math.min(this.currentIndex + 1, maxIndex);
      this.updateSlides();
    }
    
    prev() {
      if (this.isMobile) return; // No prev button functionality in mobile vertical mode
      
      if (this.currentIndex === 0) return;
      
      this.currentIndex = Math.max(0, this.currentIndex - 1);
      this.updateSlides();
    }

    goToSlide(index) {
      if (this.isMobile) return; // No slide navigation in mobile vertical mode
      
      // Make sure we don't scroll past the maximum allowed index
      const maxIndex = Math.max(0, this.slideCount - this.slidesPerView);
      this.currentIndex = Math.min(index, maxIndex);
      this.updateSlides();
    }

    startAutoplay() {
      if (this.isMobile) return; // No autoplay in mobile vertical mode
      
      if (this.autoplayEnabled && !this.autoplayInterval) {
        this.autoplayInterval = setInterval(() => {
          // Check if we reached the last possible position
          const maxIndex = Math.max(0, this.slideCount - this.slidesPerView);
          
          if (this.currentIndex >= maxIndex) {
            // Reset to first slide
            this.currentIndex = 0;
          } else {
            this.currentIndex++;
          }
          this.updateSlides();
        }, this.autoplayDelay);
      }
    }

    stopAutoplay() {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval);
        this.autoplayInterval = null;
      }
    }
  }

  // Initialize all carousels on the page
  document.addEventListener('DOMContentLoaded', () => {
    const carousels = document.querySelectorAll('.raine-carousel');
    carousels.forEach(carousel => new RaineCarousel(carousel));
  });

  } catch(e) { console.error(e); }
})();
})();
